import { useMemo } from 'react';
import { useFeatureFlag } from 'configcat-react';
import { useAuthStore } from '@/zustand/auth/store.ts';
import { parseJwt, jsonTryParse } from '@/utility';
import { CONFIGCAT_KEYS } from '@/constants/configcat-keys.ts';

export function useIsEarningsHidden() {
	const { data: authData } = useAuthStore();
	const { value: hideEarningsExpertIdListRaw } = useFeatureFlag(CONFIGCAT_KEYS.HIDE_EARNINGS_EXPERT_ID_LIST, '[]');

	const expertId = useMemo(
		() => (authData?.access_token ? parseJwt(authData.access_token)?.additional_info?.expert_id : ''),
		[authData?.access_token]
	);

	return useMemo(
		() => jsonTryParse(hideEarningsExpertIdListRaw as string).some((id: number) => id === parseInt(expertId)),
		[hideEarningsExpertIdListRaw, expertId]
	);
}
